import { render, staticRenderFns } from "./RecordCard.vue?vue&type=template&id=c1878af0&scoped=true&lang=pug&"
import script from "./RecordCard.ts?vue&type=script&lang=ts&"
export * from "./RecordCard.ts?vue&type=script&lang=ts&"
import style0 from "./RecordCard.vue?vue&type=style&index=0&id=c1878af0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1878af0",
  null
  
)

export default component.exports